import React from 'react'
import PropTypes from 'prop-types'
import { STATUS_LABELS } from './constants'
import useStyles from './styles'

export const StatusBadge = ({ status }) => {
  const classes = useStyles({ status })
  return (
    <span className={classes.statusBadge}>
      {STATUS_LABELS[status] || status}
    </span>
  )
}

StatusBadge.propTypes = {
  status: PropTypes.string.isRequired,
}

export const ConversionBadge = ({ kind }) => {
  const classes = useStyles({ kind })
  return (
    <span className={classes.kindBadge}>
      {kind === 'DIRECT' ? 'Booked from link' : 'Booked later'}
    </span>
  )
}

ConversionBadge.propTypes = {
  kind: PropTypes.oneOf(['DIRECT', 'INFLUENCED']).isRequired,
}
